module.exports = __webpack_public_path__ + "static/media/tonyt908.ef4c8029.jpg";